<template>
  <div class="wrap">
    <div class="bc bg-white p-4" style="position: relative; min-height: calc(100vh - 118px);">
      <data-table
        cell-class-name="truncate-table-cell-wrap"
        :data="data"
        :columns="option.column"
        :page="page"
        :showPage="true"
        :index="true"
        :indexFixed="true"
        :loading="loading"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
        :height="'calc(100vh - 161px)'"
      >
        <!-- 结算状态 -->
        <template #settleStatus="{ row }">
          <div :class="[settleStatusColorMap[row.settleStatus], 's-status']">
            {{ settleStatusMap[row.settleStatus] }}
          </div>
        </template>
        <!-- 支付方式 -->
        <template #payType="{ row }">
          <span>{{ payTypeMapCrud[row.payType] }}</span>
        </template>
        <!-- 菜单 -->
        <template #opt="{ row }">
          <el-button type="text" class="" @click="openDrawer(row, false)">查看结算单</el-button>
          <el-button type="text" v-if="row.settleStatus == 2" @click="openDrawer(row, true)">确认</el-button>
          <el-button type="text" v-if="row.settleStatus == 7" @click="showSettlementBillDialog(row)">确认收款</el-button>
        </template>
      </data-table>
      <el-dialog
        :title="dialogSettlementBillTitle"
        :visible.sync="dialogSettlementBillVisible"
        width="600px"
        :before-close="handleSettlementBillClose"
      >
        <el-col :span="24" class="bach-line">
          <p style="text-indent: 2em">您已在线下，收到结算款项了吗，请先确认收到，再进行线上确认。该操作不可逆，确认收款吗？</p>
        </el-col>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleSettlementBillClose">取 消</el-button>
          <el-button type="primary" @click="saveComfirm()">确 定</el-button>
        </span>
      </el-dialog>
      <el-drawer
        :title="isConfirm ? '委托代理费结算确认' : '委托代理费结算单'"
        size="80%"
        :visible.sync="drawer"
        :with-header="true"
      >
        <settlement-detail
          ref="detailDrawer"
          :id="settlementId"
          :isConfirm="isConfirm"
          :settleType="settleType"
          @closeDrawer="closeDrawer"
        >
        </settlement-detail>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import { getAnswerHList, getOfflineAnswerHList } from '@/api/wenjuan/cost'
import mixins from './settlement-bill-list-mixins'
import { assignment } from '@/assets/js/utils'
import SettlementDetail from '@/views/survey/settlement/components/settlement-detail'
import SearchFilter from '@/components/search-filter/SearchFilter'
import DataTable from '@/components/base/DataTable'
import { payTypeMapCrud } from "@/assets/js/config/payTypeMap"

export default {
  mixins: [mixins],
  components: {
    SettlementDetail,
    SearchFilter,
    DataTable
  },
  data() {
    return {
      isConfirm: false,
      settlementId: '',
      drawer: false,
      loading: false,
      payVisible: false,
      settleStatusMap: {
        1: '未发起',
        2: '待确认',
        3: '不认可',
        4: '已确认',
        5: '已撤销',
        6: '已结算',
        7: '已打款',
        8: '审批中',
        9: '审批已撤销',
        10: '审批拒绝'
      },
      settleStatusColorMap: {
        1: 'no-start',
        2: 'confirming',
        3: 'refused',
        4: 'confirmed',
        5: 'cancelled',
        6: 'settled',
        7: 'paid'
      },
      payTypeMapCrud
    }
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;

  ul {
    display: flex;
    margin-bottom: 20px;

    li {
      width: 101px;
      height: 36px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid rgba(220, 223, 230, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 49, 51, 1);
    }
  }
}
.tips {
  position: absolute;
  top: 2px;
  right: 0px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
::v-deep.el-table th div {
  line-height: 23px;
  white-space: normal;
  padding-left: 0px;
  display: block;
}
.tips-p {
  position: absolute;
  top: -40px;
  right: 115px;
  cursor: pointer;
  margin: 0;
}
.tips-p2 {
  position: absolute;
  top: -40px;
  right: 118px;
  cursor: pointer;
  margin: 0;
}
.bach-red {
  color: red;
  font-size: 18px;
  font-weight: 600;
}
.bach-blue {
  color: blue;
  font-size: 18px;
  font-weight: 600;
}
.bach-line {
  margin-bottom: 25px;
  padding-left: 10px;
}
.sum-line {
  position: absolute;
  bottom: 4px;
  left: 70px;
  .el-button {
    margin-left: 20px;
  }
}
::v-deep.avue-crud__tip {
  display: none;
}
::v-deep.el-table__body {
  a {
    margin-right: 10px;
    color: #227ffe;
  }
}
.goback {
  margin-bottom: 10px;
  color: #227ffe;
}
.no-start {
  color: #cccccc;
  background: #ffffff;
  border: 1px solid #cccccc;
}
.confirming {
  color: #ff463a;
  background: #fff6ec;
  border: 1px solid #ff463a;
}
.refused {
  color: #ff9932;
  background: #fff6ec;
  border: 1px solid #ff9932;
}
.confirmed {
  color: #4996fe;
  background: #eff6ff;
  border: 1px solid #4996fe;
}
.cancelled {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.45);
}
.settled {
  color: #b2d799;
  background: #f0f9ea;
  border: 1px solid #b2d799;
}
.paid {
  color: #fff;
  background: #53a41d;
}
.s-status {
  border-radius: 2px;
  width: 63px;
  display: inline-block;
  height: 26px;
}
::v-deep.el-drawer__body {
  overflow-y: scroll;
  background-color: #f5f5f5;
  .el-card.is-always-shadow {
    box-shadow: unset;
  }
  .el-card__body {
    background-color: #f5f5f5;
    padding: 8px;
  }
}
::v-deep.el-drawer__header {
  margin-bottom: 0px;
  padding: 10px 0 10px 20px;
  background-color: #fff;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  opacity: 0.85;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #111111;
  line-height: 16px;
}
::v-deep.el-table__row {
  background-color: #ffffff !important;
}
::v-deep.el-table__row--striped td {
  background-color: #f5f5f5 !important;
}
.avue-crud ::v-deep.el-table th {
  background-color: #f5f5f5;
}
</style>
